import {
    Dashboard as DashboardIcon,
    AdminPanelSettings as AdminIcon,
    Business as BusinessIcon,
    AccountBalance as AccountBalanceIcon,
    Settings as SettingsIcon,
    Receipt as ReceiptIcon,
    TrendingDown as TrendingDownIcon,
    AccountBalanceWallet as TDSIcon,
    PointOfSale as PointOfSaleIcon,
    NotificationsActive as NotificationsActiveIcon,
    MiscellaneousServices as MiscellaneousServicesIcon,
    Assessment as AssessmentIcon,
} from '@mui/icons-material';
import React from 'react';

export interface MenuItem {
    id: string;
    title: string;
    icon?: React.ReactNode;
    link?: string;
    permission: string;
    children?: MenuItem[];
}

export const MENU_ITEMS: MenuItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        icon: React.createElement(DashboardIcon),
        link: '/dashboard',
        permission: 'dashboard'
    },
    {
        id: 'admin',
        title: 'Admin',
        icon: React.createElement(AdminIcon),
        link: '/admin',
        permission: 'admin'
    },
    {
        id: 'clients',
        title: 'Clients',
        icon: React.createElement(BusinessIcon),
        link: '/clients',
        permission: 'clients'
    },
    {
        id: 'accounts',
        title: 'Accounts',
        icon: React.createElement(AccountBalanceIcon),
        link: '/accounts',
        permission: 'accounts'
    },
    {
        id: 'invoices-group',
        title: 'Invoices',
        icon: React.createElement(ReceiptIcon),
        permission: 'invoices',
        children: [
            {
                id: 'invoices',
                title: 'Invoices',
                icon: React.createElement(ReceiptIcon),
                link: '/invoices',
                permission: 'invoices',
            },
            {
                id: 'sales',
                title: 'Sales',
                icon: React.createElement(PointOfSaleIcon),
                link: '/invoices/sales',
                permission: 'invoices',
            },
            {
                id: 'services',
                title: 'Services',
                icon: React.createElement(MiscellaneousServicesIcon),
                link: '/invoices/services',
                permission: 'invoices',
            },
            {
                id: 'reminders',
                title: 'Reminders',
                icon: React.createElement(NotificationsActiveIcon),
                link: '/reminders',
                permission: 'invoices',
            },
        ],
    },
    {
        id: 'tds',
        title: 'TDS',
        icon: React.createElement(TDSIcon),
        link: '/tds',
        permission: 'tds'
    },
    {
        id: 'losses',
        title: 'Losses',
        icon: React.createElement(TrendingDownIcon),
        link: '/losses',
        permission: 'losses'
    },
    {
        id: 'gst-report',
        title: 'GST Report',
        icon: React.createElement(AssessmentIcon),
        link: '/invoices/gst-report',
        permission: 'invoices',
    },
    {
        id: 'settings',
        title: 'Settings',
        icon: React.createElement(SettingsIcon),
        link: '/settings',
        permission: 'settings'
    }
];
